import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin } from 'lucide-react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [modal, setModal] = useState<'privacy' | 'terms' | null>(null);
  return <footer className="bg-cream-dark text-navy pt-8 md:pt-20 pb-8 md:pb-10 border-t border-gold/20" data-id="element-99">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100">
        <div className="grid md:grid-cols-12 gap-6 md:gap-12 mb-8 md:mb-16" data-id="element-101">
          <div className="md:col-span-5 flex flex-col items-center md:items-start" data-id="element-102">
            <img src="https://cdn.magicpatterns.com/uploads/f9M1CjBpbxLWErb7AsimCo/The_same_woman_from_3In4XrRUoB.png" alt="Anisley Estanque" className="w-44 h-56 md:w-56 md:h-72 rounded-2xl object-cover object-[center_15%] border-4 border-white shadow-xl mb-4 md:mb-6" data-id="element-103" />
            <h3 className="text-2xl font-serif font-bold mb-2 text-center md:text-left" data-id="element-104">
              Anisley Estanque
            </h3>
            <p className="text-gold-dark font-medium mb-6 text-center md:text-left" data-id="element-105">
              Agente de Seguros Licenciada
            </p>

            <div className="space-y-3 w-full" data-id="element-106">
              <a href="tel:786-374-5660" className="flex items-center gap-3 text-gray-700 hover:text-navy transition-colors justify-center md:justify-start" data-id="element-107">
                <Phone className="w-5 h-5 text-navy" data-id="element-108" />
                <span data-id="element-109">786-374-5660</span>
              </a>
              <a href="mailto:anisleyestanque19@gmail.com" className="flex items-center gap-3 text-gray-700 hover:text-navy transition-colors justify-center md:justify-start" data-id="element-110">
                <Mail className="w-5 h-5 text-navy" data-id="element-111" />
                <span data-id="element-112">anisleyestanque19@gmail.com</span>
              </a>
              <div className="flex items-center gap-3 text-gray-700 justify-center md:justify-start" data-id="element-113">
                <MapPin className="w-5 h-5 text-navy shrink-0" data-id="element-114" />
                <span data-id="element-115">
                  Sirviendo a familias latinas en Florida, Texas y muchos otros
                  estados de Estados Unidos
                </span>
              </div>
            </div>
          </div>

          <div className="md:col-span-7" data-id="element-116">
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-gold/10 relative" data-id="element-117">
              <h4 className="text-xl font-serif font-bold text-navy mb-6 border-b border-gold/20 pb-4" data-id="element-118">
                UN MENSAJE FINAL DE ANISLEY...
              </h4>

              <div className="prose prose-navy text-gray-700 italic leading-relaxed" data-id="element-119">
                <p className="mb-4" data-id="element-120">
                  "Sé lo que significa trabajar duro en este país y tener miedo
                  de que una sola emergencia lo destruya todo. Por eso hago lo
                  que hago. No solo vendo seguros. Construyo tranquilidad para
                  familias como la mía, como la tuya."
                </p>
                <p className="mb-4" data-id="element-121">
                  "Y lo mejor de todo — no tienes que esperar un momento
                  especial del año para proteger a tu familia. Existen opciones
                  disponibles para ti hoy, ahora mismo, en este momento."
                </p>
                <p className="mb-6" data-id="element-122">
                  "Cuando me llames, no encontrarás a alguien que quiere
                  venderte algo. Encontrarás a alguien que genuinamente quiere
                  ayudarte a proteger lo más valioso que tienes: tu familia. Te
                  espero."
                </p>
                <p className="font-serif font-bold text-xl text-navy not-italic" data-id="element-123">
                  — Anisley Estanque <span className="text-red-500" data-id="element-124">❤️</span>
                </p>
              </div>
            </motion.div>
          </div>
        </div>

        <div className="border-t border-gray-300 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-600" data-id="element-125">
          <p data-id="element-126">
            © {new Date().getFullYear()} Anisley Estanque — Agente de Seguros
            Licenciada
          </p>

          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-127">
            <button onClick={() => setModal('privacy')} className="hover:text-gold-dark hover:underline underline-offset-4 transition-colors" data-id="element-128">
              Política de Privacidad
            </button>
            <span className="text-gray-400" data-id="element-129">·</span>
            <button onClick={() => setModal('terms')} className="hover:text-gold-dark hover:underline underline-offset-4 transition-colors" data-id="element-130">
              Términos y Condiciones
            </button>
          </div>

          <p className="flex items-center gap-2" data-id="element-131">
            <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-132"></span>
            Inscripciones disponibles los 12 meses del año.
          </p>
        </div>
      </div>

      <LegalModal type={modal} onClose={() => setModal(null)} data-id="element-133" />
    </footer>;
}